import { LIFECYCLE_STEP, TLifecycleStep, TChangeStatus, CHANGE_STATUS } from './change';

// Request through Execution is unchanged. The former Release, Effectiveness and
// Closure ending is consolidated into Completion.
export const LIFECYCLE_STEPS: TLifecycleStep[] = [
  LIFECYCLE_STEP.REQUEST,
  LIFECYCLE_STEP.ASSESSMENT,
  LIFECYCLE_STEP.PLANNING,
  LIFECYCLE_STEP.EXECUTION,
  LIFECYCLE_STEP.COMPLETION,
];

// The suggested MVP route generated from the request. Each step carries a short reason
// so the generated route is explainable, never silent.
export type TWorkflowRouteStep = {
  step: TLifecycleStep;
  reason: string;
};

// Maps a status to the lifecycle step that is currently "active" in the stepper.
export const statusToLifecycleStep = (status: TChangeStatus): TLifecycleStep => {
  switch (status) {
    case CHANGE_STATUS.DRAFT:
    case CHANGE_STATUS.SUBMITTED:
      return LIFECYCLE_STEP.REQUEST;
    case CHANGE_STATUS.IN_ASSESSMENT:
      return LIFECYCLE_STEP.ASSESSMENT;
    case CHANGE_STATUS.INITIAL_PLANNING:
      return LIFECYCLE_STEP.PLANNING;
    case CHANGE_STATUS.IN_EXECUTION:
      return LIFECYCLE_STEP.EXECUTION;
    case CHANGE_STATUS.IN_COMPLETION:
    case CHANGE_STATUS.CLOSED:
      return LIFECYCLE_STEP.COMPLETION;
    case CHANGE_STATUS.CANCELLED:
      return LIFECYCLE_STEP.REQUEST;
    default:
      return LIFECYCLE_STEP.REQUEST;
  }
};

// Future workspace tabs. Request is implemented in the initial workflow;
// the rest exist for layout compatibility and are disabled.
export const WORKSPACE_TAB = {
  OVERVIEW: 'overview',
  REQUEST: 'request',
  ASSESSMENT: 'assessment',
  IMPLEMENTATION_PLAN: 'implementation-plan',
  TASKS: 'tasks',
  DOCUMENTS: 'documents',
  REGULATORY: 'regulatory',
  APPROVALS: 'approvals',
  COMPLETION: 'completion',
  ACTIVITY: 'activity',
} as const;
export type TWorkspaceTab = (typeof WORKSPACE_TAB)[keyof typeof WORKSPACE_TAB];

export type TWorkspaceTabDef = {
  value: TWorkspaceTab;
  label: string;
  implemented: boolean;
};

// Order and labels for the workspace tab strip. `implemented: false` tabs render
// disabled to show the full future shape without building their content.
export const WORKSPACE_TABS: TWorkspaceTabDef[] = [
  { value: WORKSPACE_TAB.OVERVIEW, label: 'Overview', implemented: false },
  { value: WORKSPACE_TAB.REQUEST, label: 'Request', implemented: true },
  { value: WORKSPACE_TAB.ASSESSMENT, label: 'Assessment', implemented: false },
  { value: WORKSPACE_TAB.IMPLEMENTATION_PLAN, label: 'Implementation plan', implemented: false },
  { value: WORKSPACE_TAB.TASKS, label: 'Tasks', implemented: false },
  { value: WORKSPACE_TAB.DOCUMENTS, label: 'Documents', implemented: false },
  { value: WORKSPACE_TAB.REGULATORY, label: 'Regulatory', implemented: false },
  { value: WORKSPACE_TAB.APPROVALS, label: 'Approvals', implemented: false },
  { value: WORKSPACE_TAB.COMPLETION, label: 'Completion', implemented: false },
  { value: WORKSPACE_TAB.ACTIVITY, label: 'Activity and audit trail', implemented: false },
];
